import type { RouteRecordRaw } from "vue-router";

import { adminRoutes } from "./adminRoutes";
import { authRoutes } from "./authRoutes";
import { bookingsRoutes } from "./bookingsRoutes";
import { errorRoutes } from "./errorRoutes";
import { faqRoutes } from "./faqRoutes";
import { homeRoutes } from "./homeRoutes";
import { legalRoutes } from "./legalRoutes";
import { mapRoutes } from "./mapRoutes";
import { paymentRoutes } from "./paymentRoutes";
import { profileRoutes } from "./profileRoutes";
import { remitRoutes } from "./remitRoutes";
import { subscriptionsRoutes } from "./subscriptionsRoutes";
import { youparkRoutes } from "./youparkRoutes";

export const routes: RouteRecordRaw[] = [
  ...authRoutes,
  ...homeRoutes,
  ...mapRoutes,
  ...paymentRoutes,
  ...faqRoutes,
  ...subscriptionsRoutes,
  ...legalRoutes,
  ...profileRoutes,
  ...bookingsRoutes,
  ...remitRoutes,
  ...youparkRoutes,
  ...adminRoutes,
  ...errorRoutes
];

export { lotConfigurationTabRouteByKey } from "./youparkRoutes";
